import React from "react";
import css from "./FileFormat.css";
import PropTypes from "prop-types";

const FileFormat = props => {

  return (
    <div className={css['file-format']}>
      <h1>File Format</h1>
      <div className={css['radiobuttons']}>
        <label className={css['radiobutton']}>
          <input
            id={'xls-format'}
            name={"file-format-radio"}
            type="radio"
            checked={props.selectedFileFormat === "xls"}
            value={"xls"}
            onChange={e => props.setSelectedFileFormat(e.target.value)}
          />
          <span className={css['radiobutton-label']}>Excel Format</span>
        </label>

        <div>
          <label className={css['radiobutton']}>
            <input
              id={"csv-format"}
              name={"file-format-radio"}
              type="radio"
              value="csv"
              checked={props.selectedFileFormat === "csv"}
              onChange={e => props.setSelectedFileFormat(e.target.value)}
              aria-label="CSV Format. Select to download a ZIP file of CSV files."
            />
            <span className={css['radiobutton-label']}>CSV Format</span>
          </label>
          <div className={css["help-text"]}>
            Select to download a ZIP file of CSV files.
          </div>
        </div>
      </div>
    </div>
  )
};

FileFormat.propTypes = {
  setSelectedFileFormat: PropTypes.func.isRequired,
  selectedFileFormat: PropTypes.string.isRequired
};

export default FileFormat;
